const KEY = "dm_cookie_consent_v1";
const EN = document.documentElement.lang === "en";
const MAP_SRC = `https://www.google.com/maps?q=37.520752,15.1091433&z=16&hl=${EN ? "en" : "it"}&output=embed`;
const L = EN
  ? { custom: "Customise", save: "Save choices", map: "Map: DI MAITA – Centro Medico Polispecialistico, Viale Alcide De Gasperi 151, Catania" }
  : { custom: "Personalizza", save: "Salva scelte", map: "Mappa: DI MAITA – Centro Medico Polispecialistico, Viale Alcide De Gasperi 151, Catania" };

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY));
  } catch (e) {
    return null;
  }
}

function loadGA() {
  const id = window.SITE_CONFIG?.GA4_ID;
  if (!id || window.__gaLoaded) return;
  window.__gaLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("consent", "default", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "granted" });
  window.gtag("js", new Date());
  window.gtag("config", id, { anonymize_ip: true });
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(s);
}

function loadMap() {
  const box = document.querySelector(".map-box");
  if (!box || box.querySelector("iframe")) return;
  const f = document.createElement("iframe");
  f.src = MAP_SRC;
  f.title = L.map;
  f.loading = "lazy";
  f.referrerPolicy = "no-referrer-when-downgrade";
  f.setAttribute("data-testid", "map-iframe");
  box.appendChild(f);
  document.getElementById("map-consent")?.remove();
}

function apply(c) {
  if (c?.analytics) loadGA();
  if (c?.maps) loadMap();
}

export function initConsent() {
  const banner = document.getElementById("cookie-banner");
  const prefs = document.getElementById("cookie-prefs");
  const cA = document.getElementById("c-analytics");
  const cM = document.getElementById("c-maps");
  const customBtn = document.getElementById("cookie-custom");

  const save = (c) => {
    const val = { analytics: !!c.analytics, maps: !!c.maps, ts: new Date().toISOString() };
    localStorage.setItem(KEY, JSON.stringify(val));
    banner.hidden = true;
    apply(val);
  };
  const open = () => {
    const c = read();
    cA.checked = !!c?.analytics;
    cM.checked = !!c?.maps;
    prefs.hidden = true;
    customBtn.textContent = L.custom;
    banner.hidden = false;
  };

  document.getElementById("cookie-accept").addEventListener("click", () => save({ analytics: true, maps: true }));
  document.getElementById("cookie-reject").addEventListener("click", () => save({ analytics: false, maps: false }));
  customBtn.addEventListener("click", () => {
    if (prefs.hidden) {
      prefs.hidden = false;
      customBtn.textContent = L.save;
    } else save({ analytics: cA.checked, maps: cM.checked });
  });
  document.getElementById("open-cookie")?.addEventListener("click", open);
  document.getElementById("load-map")?.addEventListener("click", () => {
    const c = read() || { analytics: false };
    save({ ...c, maps: true });
  });

  const current = read();
  if (current) apply(current);
  else banner.hidden = false;
}
